import styled from '@emotion/styled';

export const Container = styled.div`
  .ant-card-cover {
    img {
      height: 200px;
      width: 100%;
      object-fit: cover;
    }
  }
`;

export const NoStores = styled.div`
  text-align: center;
`;
